<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <ts-card>
          <ts-card-wrapper>
            <academic-program v-model="model" :validate="errors" />
          </ts-card-wrapper>
        </ts-card>
        <advance-option class="ts-mt-4" v-model="model" :validate="errors" />
      </div>
      <div class="col-md-8">
        <ts-card>
          <ts-card-wrapper>
            <question-info v-model="model" :validate="errors" />
            <div class="row">
              <div class="col-md-12 text-right">
                <ts-button
                  class="mr-2"
                  @click="$router.push({ name: 'question' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  outline
                  color="primary"
                  class="mr-2"
                  @click.prevent="saveAddNew"
                  :waiting="waiting_save_add_new"
                  >{{ $t('save_add_new') }}</ts-button
                >
                <ts-button
                  :waiting="saving"
                  color="primary"
                  @click.prevent="save"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import AcademicProgram from './component/academic-program'
import QuestionInfo from './component/question-info'
import AdvanceOption from './component/advance-option'
export default {
  name: 'StaffQuestionEdit',
  components: {
    AcademicProgram,
    QuestionInfo,
    AdvanceOption
  },
  data() {
    return {
      model: {
        acp_id: null,
        acps_id: null,
        level_id: null,
        grade_id: null,
        sc_bas_id: null,
        question_code: '',
        question_name: '',
        explanation: '',
        question_type_id: 1,
        question_catalog_id: null,
        max_score: 1,
        penalty_rate: 0,
        penalty_type: '%',
        answer_option_id: 1,
        difficulty_level_id: 1,
        answer_list: [],
        is_active: true
      },
      saving: false,
      waiting_save_add_new: false,
      errors: new Errors()
    }
  },
  computed: {},
  methods: {
    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('eschool/eExam/question/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'question' })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.waiting_save_add_new = true
      this.$store
        .dispatch('eschool/eExam/question/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting_save_add_new = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting_save_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    clearForm() {
      this.model = {
        acp_id: null,
        acps_id: null,
        level_id: null,
        grade_id: null,
        sc_bas_id: null,
        question_code: '',
        question_name: '',
        explanation: '',
        question_type_id: 1,
        question_catalog_id: null,
        max_score: 1,
        penalty_rate: 0,
        penalty_type: '%',
        answer_option_id: 1,
        difficulty_level_id: 1,
        answer_list: [],
        is_active: true
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('eschool/eExam/question/SET_EDIT_DATA')
    }
    next()
  }
}
</script>
